export const SortableEntriesDefaultAnimationDuration = 250;
